import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { HideCardIdStr, HidePhoneStr } from '@/assets/utils/utils.js';
import { encrypt, decrypt } from '../../assets/utils/cryptoUtil.js';
import { getProcCheckProgress, getProcGetQueueAll, getCurrentCheckUserInfo as _getCurrentCheckUserInfo } from '@/api/module/user';
import { Toast, Dialog } from "vant";
import user from "@/store/modules/user";
import HtmlPanel from "@/components/HtmlPanel";
import JsBarcode from "jsbarcode";
export default {
  name: "index",
  // components: {HtmlPanel},-
  data: function data() {
    return {
      skinName: window.appSetting.queuePage.skinName,
      tabsSkin: window.appSetting.tabs,
      serialno: "",
      unCheckedList: [],
      //未检项目数据
      checkedList: [],
      //项目数据
      queueData: [],
      //排队数据
      show: false,
      serialnoVal: "",
      payShow: false,
      queueTips: window.g.VUE_APP_QUEUE_TIPS,
      user: {},
      cardid: "",
      name: "",
      getPageUrl: window.g.VUE_APP_SUB_DIR + '/HtmlPanels/notice.html',
      hospiatlName: window.g.VUE_APP_HOSPITALNAME,
      todayQueueInfo: null
    };
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.chatTimer);
    this.chatTimer = null;
  },
  mounted: function mounted() {
    var _this = this;

    this.user = JSON.parse(localStorage.getItem("loginuser"));

    if (this.user == null) {
      this.showScanCode = true;
      return;
    }

    this.cardid = this.hideCardid(decrypt(this.user.cardid));
    this.name = this.hideName(decrypt(this.user.name));
    this.getCurrentCheckUserInfo();
  },
  filters: {
    checkStatusFilter: function checkStatusFilter(value) {
      if (value == '2') {
        return '已弃检';
      } else if (value == '3') {
        return '续检';
      } else if (value == '4') {
        return '报告先出';
      }
    },
    checkStatusFilterStyle: function checkStatusFilterStyle(value) {
      if (value == '2') {
        return 'color:red';
      } else if (value == '3') {
        return '续检';
      } else if (value == '4') {
        return '报告先出';
      }
    }
  },
  methods: {
    refresh_progress: function refresh_progress(serialno) {
      var _this = this;

      var params = {
        serialno: serialno
      };
      getProcCheckProgress(params).then(function (res) {
        if (res.code == 200) {
          _this.$nextTick(function () {
            _this.unCheckedList = [];
            _this.checkedList = [];
            res.data.forEach(function (item) {
              if (item.CheckStatus == "0" || item.CheckStatus == "2") {
                _this.unCheckedList.push(item);
              }

              if (item.CheckStatus == "1") {
                _this.checkedList.push(item);
              }
            });
          });
        }
      });
    },
    refresh_queue: function refresh_queue(serialno) {
      var _this = this;

      var params = {
        serialno: serialno
      };
      getProcGetQueueAll(params).then(function (res) {
        if (res.code == 200) {
          _this.$nextTick(function () {
            var _this2 = this;

            _this.queueData = [];
            Dialog.close();
            var dialogTxt = "";
            res.data.forEach(function (item) {
              if (item.ClinicName != "") {
                if (_this2.queueTips) {
                  _this2.queueTips.forEach(function (tem) {
                    if (tem.clinicid == item.ClinicID) {
                      dialogTxt = dialogTxt + tem.msg;
                    }
                  });
                }

                _this.queueData.push(item);
              }
            });

            if (dialogTxt != "") {
              Dialog.alert({
                message: dialogTxt,
                theme: 'round-button'
              }).then(function () {// on close
              });
            }
          });
        }
      });
    },
    getCurrentCheckUserInfo: function getCurrentCheckUserInfo() {
      var _this3 = this;

      var _this = this;

      var params = {
        patientid: this.user.patientid
      };

      _getCurrentCheckUserInfo(params).then(function (res) {
        if (res.code == 200) {
          var resData = res.data;
          _this3.todayQueueInfo = resData;

          _this3.$nextTick(function () {
            if (resData == null) {
              Toast("未查询到体检信息");
              clearInterval(_this.chatTimer);
              _this.chatTimer = null;
            } else {
              this.$router.push({
                name: 'intelligentGuide',
                query: {
                  serialno: resData.SerialNo
                }
              }); //跳转到首页
              // this.serialno = resData.SerialNo
              // JsBarcode("#barcode", this.serialno,{
              //   lineColor: "#000",
              //   width: 3,
              //   height: 60,
              //   displayValue: false
              // });
              // _this.refresh_progress(resData.SerialNo);
              // _this.refresh_queue(resData.SerialNo);
              // _this.chatTimer = setInterval(()=>{
              //   _this.refresh_progress(resData.SerialNo);
              //   _this.refresh_queue(resData.SerialNo);
              // },9000)
              // _this.show = false
            }
          });
        }
      });
    },
    hideCardid: function hideCardid(str) {
      if (str == "") {
        return "";
      }

      var len = str.length - 3 - 4;
      var xing = '';

      for (var i = 0; i < len; i++) {
        xing += '*';
      }

      return str.substring(0, 3) + xing + str.substring(str.length - 4);
    },
    hideName: function hideName(str) {
      if (str == "") {
        return "";
      }

      var len = str.length - 1;
      var xing = '';

      for (var i = 0; i < len; i++) {
        xing += '*';
      }

      return xing + str.substring(str.length - 1);
    }
  }
};